import React, { useEffect, useState } from "react";

import styled from "styled-components/macro";

import createSharedNameString from "Payments/ManagePaymentMethods/createSharedNameString";

import FnrCheckbox from "UI/FnrCheckbox";
import { useKeepOpenList } from "UI/FnrPopover2";

import { usePaymentMethod } from "../PaymentMethodContext";

import { QuickControlButton } from "./";

export default function TTGButton({
  disabled = false,
  savePaymentMethod,
  sharableWith,
}) {
  const [loading, setLoading] = useState(false);
  const { sharedWithOtherHoH, paymentType } = usePaymentMethod().state;
  const isBank = paymentType === "bank";

  const { addReason, removeReason, showing, showPopover, hidePopover } =
    useKeepOpenList();

  useEffect(() => {
    !showing && setLoading(false);
  }, [showing]);

  const handleClick = () => {
    setLoading(true);
    addReason("is_saving");
    savePaymentMethod({ sharedWithOtherHoH: !sharedWithOtherHoH }, () => {
      removeReason("is_saving");
      hidePopover();
    });
  };

  const shareWithNames = createSharedNameString(sharableWith);

  return (
    <QuickControlButton
      icon={(sharedWithOtherHoH ? "fas" : "far") + " fa-user-friends"}
      text="Share"
      onButtonClick={showPopover}
      showPopover={showing}
      attemptClosePopover={hidePopover}
      disabled={disabled}
      faded={!sharedWithOtherHoH}
    >
      <Wrapper>
        {`You can share this ${
          isBank ? "account" : "card"
        } with other adults in your household so they can use it to give gifts to your church.`}
        <ButtonHolder>
          <FnrCheckbox
            on={sharedWithOtherHoH}
            onClick={handleClick}
            loading={loading}
          >
            {`Share this ${isBank ? "account" : "card"} with ` + shareWithNames}
          </FnrCheckbox>
        </ButtonHolder>
      </Wrapper>
    </QuickControlButton>
  );
}

const Wrapper = styled.div`
  padding: 12px;
  width: 240px;
  line-height: 1.3em;
`;

const ButtonHolder = styled.div`
  margin-top: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.5);
  padding-top: 12px;
`;
